import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const toolsApi = createApi({
  reducerPath: "tools",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token
      headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["years", "mail"],
  endpoints: (builder) => ({
    financialYears: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetFinancialYears",
              method: "GET",
              params: data
          }
      },
      providesTags: ["years"],
    }),
    detailsByFinancialYear: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetFinancialYears",
              method: "GET",
              params: {
                keyYear: data
              }
          }
      },
      providesTags: ["years"],
    }),
    createFinancialYear: builder.mutation({
      query: (data) => {
        return {
          url: "/Tools/CreateFinacialYear",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["years"],
    }),
    updateFinancialYear: builder.mutation({
      query: (data) => {
        return {
          url: "/Tools/updateFinancialYear",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["years"],
    }),
    deleteFinancialYear: builder.mutation({
      query: (data) => {
        return {
          url: `/Tools/DeleteFinancialYear?keyID=${data}`,
          method: "POST",
        };
      },
      invalidatesTags: ["years"],
    }),
    getMailSetting: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetMailSettings",
              method: "GET",
              params: data
          }
      },
      providesTags: ["mail"],
    }),
    updateMailSetting: builder.mutation({
      query: (data) => {
        return {
          url: "/Tools/UpdateMailSettings",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["mail"],
    }),
    getMasterSetting: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetMasterSettings",
              method: "GET",
              params: data
          }
      },
      providesTags: ["setting"],
    }),
    updateMasterSetting: builder.mutation({
      query: (data) => {
        return {
          url: "/Tools/UpdateMasterSettings",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["setting"],
    }),
    getFileTools: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetFileTools",
              method: "GET",
              params: data
          }
      },
      providesTags: ["files"],
    }),
    createFileTool: builder.mutation({
      query: (data) => {
        return {
          url: "/Tools/createFileTool",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["files"],
    }),
    deleteFileTool: builder.mutation({
      query: (data) => {
          return {
            url: `/Tools/DeleteFileTool?keyID=${data}`,
            method: "POST"
          }
      },
      invalidatesTags: ["files"],
    }),
    taxPercentage: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetDefaultTaxPercentage",
              method: "GET",
              params: data
          }
      },
      providesTags: ["tax"],
    }),   
    getTaxPercentList: builder.query({
      query: (data) => {
          return {
              url: "/Tools/GetTaxPercentList",
              method: "GET",
              params: data
          }
      },
      providesTags: ["tax"],
    }),
  }),
});

export const { 
  useFinancialYearsQuery, 
  useDetailsByFinancialYearQuery,
  useCreateFinancialYearMutation,
  useUpdateFinancialYearMutation,
  useDeleteFinancialYearMutation,
  useGetMailSettingQuery,
  useUpdateMailSettingMutation,
  useGetMasterSettingQuery,
  useUpdateMasterSettingMutation,
  useGetFileToolsQuery,
  useCreateFileToolMutation,
  useDeleteFileToolMutation,
  useTaxPercentageQuery,
  useGetTaxPercentListQuery
} = toolsApi;
